import _sourceMapGenerator from "./lib/source-map-generator";
import _sourceMapConsumer from "./lib/source-map-consumer";
import _sourceNode from "./lib/source-node";
var exports = {};

/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */
exports.SourceMapGenerator = _sourceMapGenerator.SourceMapGenerator;
exports.SourceMapConsumer = _sourceMapConsumer.SourceMapConsumer;
exports.SourceNode = _sourceNode.SourceNode;
export default exports;
export const SourceMapGenerator = exports.SourceMapGenerator,
      SourceMapConsumer = exports.SourceMapConsumer,
      SourceNode = exports.SourceNode;